import { render, staticRenderFns } from "./CommissionConfig.vue?vue&type=template&id=3377254f&"
import script from "./CommissionConfig.vue?vue&type=script&lang=js&"
export * from "./CommissionConfig.vue?vue&type=script&lang=js&"
import style0 from "./CommissionConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports